<template>
    <div>
        <div v-if="active === index">
            <YoutubePlayer :source="data.meta.snippet.resourceId.videoId" />
        </div>

        <div v-else class="cursor-pointer">
            <div class="group rounded-md relative overflow-hidden" @click="this.$emit('update:active', index)">
                <div class="flex flex-row gap-4 h-full">
                    <div class="w-1/4 flex items-center justify-start">
                        <img alt="Video" :src="data?.meta?.snippet?.thumbnails?.high?.url" ref="image" class="h-full w-full rounded-md object-cover" />
                    </div>
                    <div class="w-3/4 flex flex-col justify-between">
                        <strong class="mt-2 line-clamp-1">
                            {{ data.meta.snippet.title }}
                        </strong>
                        <div class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center mt-2">
                            <span>
                                {{ $t('plain_view') }}
                            </span>
                            <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['active', 'data', 'index'],
    emits: ['update:active']
};
</script>
